import React from "react";
import { Check } from "lucide-react";
import { cn } from "~/lib/cn";

export const FeatureCheck = (props: React.SVGProps<SVGSVGElement>) => (
  <div
    className={cn(
      "bg-brand-100 flex h-5 w-5 shrink-0 grow-0 items-center justify-center gap-2 rounded-full",
      props.className,
    )}
  >
    <Check
      {...props}
      className={cn("text-brand-700", props.className, "h-3 w-3")}
    />
  </div>
);
